import { action, makeObservable, observable, autorun } from 'mobx';
import { ADULT_NUM, CHILD_NUM, REMAINS } from '@/constants';

interface IBookingStore {
  adultNum: number;
  childNum: number;
  depBusStopName: string;
  depBusStopCode: string;
  arrBusStopName: string;
  arrBusStopCode: string;
  depTime: string;
  arrTime: string;
  serviceDate: string;
  depOrArr: string;
  tUrl: string;
  remains: number;
}

const storage = sessionStorage;

export class Booking {
  @observable booking: IBookingStore = JSON.parse(
    storage.getItem('booking') || '{}'
  );

  constructor() {
    makeObservable(this);
  }

  @action
  setBooking = (booking: IBookingStore) => {
    this.booking = booking;
  };

  @action
  getBooking = () => {
    return this.booking;
  };

  @action
  clear = (key?: keyof IBookingStore) => {
    if (key) {
      if (key === ADULT_NUM || key === CHILD_NUM || key === REMAINS) {
        this.booking[key] = 0;
      } else {
        this.booking[key] = '';
      }
    } else {
      this.booking = {
        adultNum: 0,
        childNum: 0,
        depBusStopName: '',
        depBusStopCode: '',
        arrBusStopName: '',
        arrBusStopCode: '',
        depTime: '',
        arrTime: '',
        serviceDate: '',
        depOrArr: '',
        tUrl: '',
        remains: 0
      };
    }
  };
}

const booking = new Booking();

autorun(() => {
  sessionStorage.setItem('booking', JSON.stringify(booking.booking));
});

export default booking;
